// const main = () => import(/* webpackChunkName: "core-vs" */'../components/layouts/pc3/layout-main.vue')

import main from  "../components/layouts/pc3/layout-main.vue"

function setLayout(app, routes) {

    routes.forEach((route, index) => {
       
        // if (index == 0) {
        //     route.component = main
        //     return true
        // } 

        if (route.children && route.children.length > 0) {
            if (!route.component) route.component = main    //main
            return true
        }
        route = {
            name: route.name + "-parent",
            text: route.text,
            path: `/main`,
            component: main,
            redirect: { name: route.name },
            icon: route.icon,
            hasChildren: false,
            children: [route]
        }
        routes[index] = route;
    })
}
export default {
    name: "pc3",
    maxWidth: 2560,
    minWidth: 1024,
    login: null,
    text: "新的pc布局",
    desc: "新的pc布局",
    layout: setLayout
}